// extracted by mini-css-extract-plugin
export default {"modal":"DevicesModal__modal-ono08","content":"DevicesModal__content-UravD","leftSection":"DevicesModal__leftSection-QqMPW","rightSection":"DevicesModal__rightSection-OfFny"};